<div
  [class]="
    'flex flex-col gap-(--processstatuscard-gap) rounded-(--processstatuscard-border-radius) px-(--processstatuscard-padding-x) py-(--processstatuscard-padding-y) ' +
    (hasBorder()
      ? 'border-(length:--processstatuscard-border-width,var(--border-width-xs)) border-(--processstatuscard-border-color) '
      : '') +
    (isHighlighted()
      ? 'bg-linear-to-b from-(--gradients-tertiary-start) via-(--gradients-tertiary-middle) to-(--gradients-tertiary-stop)'
      : 'bg-(--processstatuscard-background)')
  "
>
  <!-- Chip -->
  @if (chipConfig(); as chip) {
    <div class="self-start">
      <app-dynamic
        componentName="Chip"
        [props]="{ config: chip }"
      />
    </div>
  }

  <!-- Status Message Section -->
  <div class="flex flex-col gap-2">
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: statusMessageConfig() }"
    />
    @if (bodyMessageConfig(); as bodyMsg) {
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: bodyMsg }"
      />
    }
  </div>

  <!-- Progress Bar -->
  <app-dynamic
    componentName="ProgressBar"
    [props]="{ config: progressConfig() }"
  />

  <!-- Button -->
  @if (config().button; as btn) {
    <app-dynamic
      componentName="Button"
      [props]="{ config: btn }"
      (action)="onButtonClick($event)"
    />
  }
</div>
